package app.bloomey.web.modules.feedback

import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.flow.collectLatest

class FeedbackInputHandler : InputHandler<
        FeedbackContract.Inputs,
        FeedbackContract.Events,
        FeedbackContract.State> {

    private val repository = FeedbackRepository()
    override suspend fun InputHandlerScope<
            FeedbackContract.Inputs,
            FeedbackContract.Events,
            FeedbackContract.State>.handleInput(
        input: FeedbackContract.Inputs,
    ): Unit = when (input) {
        is FeedbackContract.Inputs.GetPage -> {
            repository.getFeedbacks(page = input.page, size = input.size, input.query).collectLatest { nextPage ->
                updateState {
                    var initState = it.copy(itemsState = nextPage)
                    if (nextPage.isSuccess) {
                        initState = initState.copy(page = input.page)
                    }
                    initState
                }
            }
        }
    }
}
